// extracted by mini-css-extract-plugin
export var productImage = "_qu-1";
export var viewLink = "_qu-2";
export var wishlistItem = "_qu-0";